import { Appointment, TaskListItem } from '@myapp/contract'

export function detectAppointmentTransferOverlaps(
  appointments: Appointment[],
  editingAppointmentId?: string | null,
): { transferTravel: Set<string>; transferDeparture: Set<string> } {
  const travel = new Set<string>()
  const departure = new Set<string>()

  const visible = appointments.filter((a) => a.id !== editingAppointmentId)
  if (visible.length < 2) return { transferTravel: travel, transferDeparture: departure }

  const getBlockMinutes = (appt: Appointment) => {
    const ws = new Date(appt.actualStart ?? appt.plannedStart)
    const travel = appt.actualTravelDuration ?? appt.plannedTravelDuration
    const work = appt.actualWorkDuration ?? appt.plannedWorkDuration
    const departure = appt.actualDepartureDuration ?? appt.plannedDepartureDuration
    const startMin = ws.getHours() * 60 + ws.getMinutes() - travel
    const endMin = ws.getHours() * 60 + ws.getMinutes() + work + departure
    return { startMin, endMin }
  }

  const sorted = [...visible].sort((a, b) => getBlockMinutes(a).startMin - getBlockMinutes(b).startMin)

  for (let i = 0; i < sorted.length - 1; i++) {
    const curr = sorted[i]
    const next = sorted[i + 1]
    const currBlock = getBlockMinutes(curr)
    const nextBlock = getBlockMinutes(next)

    if (currBlock.endMin >= nextBlock.startMin) {
      if (curr.plannedDepartureDuration > 0 && next.plannedTravelDuration === 0) departure.add(curr.id)
      if (next.plannedTravelDuration > 0 && curr.plannedDepartureDuration === 0) travel.add(next.id)
    }
  }

  return { transferTravel: travel, transferDeparture: departure }
}

export function detectTaskTransferOverlaps(
  tasks: TaskListItem[],
  editingTaskId?: number,
): { transferTravelTasks: Set<number>; transferDepartureTasks: Set<number> } {
  const travel = new Set<number>()
  const departure = new Set<number>()

  const visible = tasks.filter((t) => t.id !== editingTaskId)
  if (visible.length < 2) return { transferTravelTasks: travel, transferDepartureTasks: departure }

  const getTaskMinutes = (task: TaskListItem) => {
    const ws = new Date(task.actualStart ?? task.plannedStart!)
    const travel = task.actualTravelDuration ?? task.plannedTravelDuration
    const work = task.actualWorkDuration ?? task.plannedWorkDuration
    const departure = task.actualDepartureDuration ?? task.plannedDepartureDuration
    const startMin = ws.getHours() * 60 + ws.getMinutes() - travel
    const endMin = ws.getHours() * 60 + ws.getMinutes() + work + departure
    return { startMin, endMin }
  }

  const sorted = [...visible].sort((a, b) => getTaskMinutes(a).startMin - getTaskMinutes(b).startMin)

  for (let i = 0; i < sorted.length - 1; i++) {
    const curr = sorted[i]
    const next = sorted[i + 1]
    const currBlock = getTaskMinutes(curr)
    const nextBlock = getTaskMinutes(next)

    if (currBlock.endMin >= nextBlock.startMin) {
      if (curr.plannedDepartureDuration > 0 && next.plannedTravelDuration === 0) departure.add(curr.id)
      if (next.plannedTravelDuration > 0 && curr.plannedDepartureDuration === 0) travel.add(next.id)
    }
  }

  return { transferTravelTasks: travel, transferDepartureTasks: departure }
}
